import React from 'react';

export default function FarmerHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="29.0,27.96 15.15,27.96 15.15,14.12 29.0,14.12" fill="#BC9E2E" />
      <polygon points="15.15,27.96 29.0,27.96 24.85,25.88 11.0,25.88" fill="#6A5919" opacity="0.95" />
      <polygon points="15.15,27.96 11.0,25.88 11.0,12.04 15.15,14.12" fill="#6A5919" opacity="0.95" />
      <polygon points="29.22,28.16 15.03,28.16 15.03,13.97 29.22,13.97" fill="#BC9E2E" />
      <polygon points="15.03,28.16 29.22,28.16 24.97,26.03 10.78,26.03" fill="#6A5919" opacity="0.95" />
      <polygon points="15.03,28.16 10.78,26.03 10.78,11.84 15.03,13.97" fill="#6A5919" opacity="0.95" />
      <polygon points="10.31,22.08 38.0,22.08 29.69,17.92 2.0,17.92" fill="#6A5919" opacity="0.95" />
    </svg>
  );
}
